import React, { useEffect } from 'react';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import gdprEmailIcon from './images/icon-gdpr-email.svg';

import styles from './DirectPromotion.scss';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingModalActions from '../../../OnboardingModalActions';
import HeaderIcon from '../../../HeaderIcon';
import PERMISSION_TYPES from '../../../../../../constants/consents/permissionTypes';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';

const DirectPromotion = () => {
  const { state, track, dispatch } = useOnboardingContext();
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.directPromotion),
      action: 'screen_enter'
    });
  }, [track]);

  const { alert } = state;

  return (
    <>
      <ModalBodyWithAlerts alert={alert}>
        <HeaderIcon source={gdprEmailIcon} />
        <h2>{t('direct_promo.title')}</h2>
        <p>{t('direct_promo.subtitle')}</p>
      </ModalBodyWithAlerts>

      <OnboardingModalActions className={styles.modalActions}>
        <ActionButton
          variant="default"
          onClick={() =>
            stepForward({
              action: ACTIONS.denied,
              permissionType: PERMISSION_TYPES.directPromotion
            })
          }
          data-cy="direct-promo-deny-next-step-btn"
          isProcessing={isProcessing}
          className={styles.actionBtn}
        >
          {t('direct_promo.no_thanks')}
        </ActionButton>
        <ActionButton
          variant="primary"
          onClick={() =>
            stepForward({
              action: ACTIONS.approved,
              permissionType: PERMISSION_TYPES.directPromotion
            })
          }
          data-cy="direct-promo-accept-next-step-btn"
          className={styles.actionBtn}
        >
          {t('direct_promo.yes_please')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default DirectPromotion;
